import {PropsWithChildren} from 'react';

import cn from 'classnames';

import {useViewportSize} from '@/hooks/useViewportSize';

import s from './MainContainer.module.css';

// https://www.figma.com/design/FZC0HRoElXFiPO8yOLHsTF/Invest?node-id=6881-73004&t=7DOX9YPfKvMXj7do-1
export function MainContainer({children, className}: PropsWithChildren<{className?: string}>): JSX.Element {
  const size = useViewportSize();

  return (
    <div className={cn(s.root, className)} style={{width: size.width, height: size.height}}>
      <div className={s.borderDesktop}>{children}</div>
    </div>
  );
}
